
(function ($) {

    $(document).ready(function () {

        $(".custom-option").on("click", function () {
            if ($(this).parents('.js-people-filter-bar').length) {
                var filter = $(this).data("value");
                $(this).parents('.js-people-filter-bar').find('.listings-entry').each(function () {
                    if ($(this).data("people") == filter) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            }
        });

    });

})(jQuery);
